/**
 * Clicking anywhere on a date field opens its calendar (floor complaint,
 * 2026-10-18: "the date picker needs the user to click exactly on the calendar
 * icon"). Browsers open the native picker only from the icon; a click on the text
 * just selects the day/month/year segment. One document listener covers every
 * date input in the app, present and future. Keyboard entry still works: this
 * only reacts to a click.
 */
const PICKER_TYPES = new Set(["date", "datetime-local", "month", "time", "week"]);

export const openPickerFor = target => {
  if (!(target instanceof HTMLInputElement)) return false;
  if (!PICKER_TYPES.has(target.type) || target.disabled || target.readOnly) return false;
  if (typeof target.showPicker !== "function") return false;
  try {
    target.showPicker();
    return true;
  } catch {
    // Not allowed here (e.g. inside a cross-origin frame) — the icon still works.
    return false;
  }
};

export function installDatePickerOnClick(doc = document) {
  const onClick = event => openPickerFor(event.target);
  doc.addEventListener("click", onClick);
  return () => doc.removeEventListener("click", onClick);
}
